import React from 'react';
import PropTypes from 'prop-types';

// Config
import { crudConfig } from '../../../../conf/conceptDeterminationMethods';

// Components
import { MaterialIcon } from '../../../../../components/MaterialIcon';
import { Dialog } from '../../../../../components/Dialog';
import { DialogHeader } from '../../../../../components/DialogHeader';
import { DialogBody } from '../../../../../components/DialogBody';
import { DialogFooter } from '../../../../../components/DialogFooter';
import { Button } from '../../../../../components/Button';
import FeedbackCard from '../../../../../components/FeedbackCard';

// Hooks
import { useDeleteConceptDeterminationMethod } from '../../../api/hooks/useDeleteConceptDeterminationMethod';

export const DeleteConceptDeterminationMethod = ({ data, closeDialog, sessionToken }) => {
    const [wasSuccessful, setWasSuccessful] = React.useState(false);
    const deleteConceptDeterminationMethod = useDeleteConceptDeterminationMethod({
        crudConfig,
        sessionToken,
        onSuccessCb: () => {
            setFatalError(null);
            setWasSuccessful(true);
            setTimeout(() => {
                CloseDialog();
            }, 500);
        },
        onErrorCb: (e) => {
            setFatalError(e);
            setWasSuccessful(false);
        }
    });
    const [fatalError, setFatalError] = React.useState(null);
    const [deleteData, setDeleteData] = React.useState();

    React.useEffect(() => {
        if (!deleteData) {
            setDeleteData(data);
        }
    }, [data]);

    const CloseDialog = () => {
        return typeof closeDialog === 'function' ? closeDialog() : null;
    };

    const Delete = () => {
        deleteConceptDeterminationMethod.mutate(data.codeId);
    };

    return (
        <div style={{ height: `30rem` }}>
            <Dialog close={CloseDialog} size="md" visible id="concept-determination-method-manager-delete">
                <DialogHeader close={CloseDialog}>{`Delete ${deleteData?.code}${deleteData?.displayName ? ` - ${deleteData?.displayName}` : ''}`}</DialogHeader>
                <DialogBody>
                    Are you sure you wish to delete this concept determination method?
                    {fatalError != null && (
                        <FeedbackCard
                            intent={'danger'}
                            feedback={{
                                heading: `An error has occurred.`,
                                message: `Please wait a few moments before trying your request
        again.`
                            }}
                            details={fatalError}
                        />
                    )}
                </DialogBody>
                <DialogFooter>
                    {deleteConceptDeterminationMethod.isLoading && (
                        <div style={{ marginRight: '0.5rem' }}>Loading...</div>
                    )}
                    {!deleteConceptDeterminationMethod.isLoading && wasSuccessful && (
                        <div style={{ marginRight: '0.5rem' }}>
                            <MaterialIcon icon={'done_outline'} color={'#04846D'} />
                        </div>
                    )}
                    <Button
                        appearance="primary"
                        text
                        onClick={Delete}
                        disabled={deleteConceptDeterminationMethod.isLoading}
                    >
                        Delete
                    </Button>
                    <Button appearance="secondary" text onClick={CloseDialog}>
                        Cancel
                    </Button>
                </DialogFooter>
            </Dialog>
        </div>
    );
};

DeleteConceptDeterminationMethod.propTypes = {
    sessionToken: PropTypes.string.isRequired,
    data: PropTypes.object,
    closeDialog: PropTypes.func.isRequired
};

export default DeleteConceptDeterminationMethod;
